// Path: /home/jason/src/AgileView/autovision-ui/src/components/wizards/CPNameStep.tsx

import React, { useRef, useState, useEffect } from 'react'
import { Form, Row, Col, Card } from 'react-bootstrap'
import { useProject } from './NewProjectContext'

interface CPNameStepProps {
  onNext?: () => void
}

const CPNameStep: React.FC<CPNameStepProps> = ({ onNext }) => {
  const projectNameRef = useRef<HTMLInputElement>(null)
  const { projectName, setName, description, setDescription } = useProject()
  const [localName, setLocalName] = useState(projectName || '')
  const [touched, setTouched] = useState(!!projectName)

  useEffect(() => {
    if (projectNameRef.current) {
      projectNameRef.current.focus()
    }
  }, [])

  const handleSetName = (name: string) => {
    setLocalName(name)
    setName(name)
  }

  const isNameValid = localName.length >= 3 && localName.length <= 50
  const showNameError = touched && !isNameValid

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (onNext) {
      onNext()
    }
  }

  return (
    <Row className="justify-content-center">
      <Col xs={12} md={8} lg={6}>
        <Card
          className="border-0"
          style={{
            backgroundColor: '#2b2b2b',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          }}
        >
          <Card.Body className="p-4">
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-4">
                <Form.Label className="fw-semibold text-light">Project Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter a unique name for your project"
                  value={localName}
                  onChange={(e) => {
                    handleSetName(e.target.value)
                    setTouched(true)
                  }}
                  isInvalid={showNameError}
                  required
                  ref={projectNameRef}
                  className="form-control-lg"
                  style={{
                    backgroundColor: '#363636',
                    border: '1px solid #404040',
                    color: '#fff',
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Project name must be between 3 and 50 characters
                </Form.Control.Feedback>
                <Form.Text className="text-light opacity-75">
                  Choose a descriptive name that helps you identify this project
                </Form.Text>
              </Form.Group>

              <Form.Group>
                <Form.Label className="fw-semibold text-light">Project Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Describe the purpose and goals of your project"
                  value={description || ''}
                  onChange={(e) => setDescription(e.target.value)}
                  className="form-control-lg"
                  style={{
                    backgroundColor: '#363636',
                    border: '1px solid #404040',
                    color: '#fff',
                  }}
                />
                <Form.Text className="text-light opacity-75">
                  Optional: Add details about what this project aims to achieve
                </Form.Text>
              </Form.Group>
            </Form>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default CPNameStep
